import React from "react";

interface PageSectionProps {
  marker: string;
  noTop?: boolean;
  topPadClass?: string;
  className?: string;
  children: React.ReactNode;
}

/**
 * Standard KODE page section: 2-col left rail (mono section marker)
 * + 10-col content, inside a swiss-grid.
 */
const PageSection: React.FC<PageSectionProps> = ({
  marker,
  noTop = false,
  topPadClass,
  className = "",
  children,
}) => {
  const sectionClass = `swiss-section ${noTop ? "!border-t-0" : ""} ${
    topPadClass || ""
  } ${className}`.trim();
  return (
    <section className={sectionClass}>
      <div className="swiss-grid">
        <div className="col-span-12 lg:col-span-2 mb-6 lg:mb-0">
          <span className="swiss-num">{marker}</span>
        </div>
        <div className="col-span-12 lg:col-span-10">{children}</div>
      </div>
    </section>
  );
};

export default PageSection;
